(function (skyward, $, undefined)
{
    "use strict";
    skyward.distinctmultiselecteel = skyward.distinctmultiselecteel || {};

    const dmseDataByBrowse = new WeakMap();

    const requestHandler = skyward.extensions.getSingleRequestHandler();

    const dmseIdGenerator = skyward.extensions.getIdGenerator("popup", "_distinctMultiSelectEELBrowse");

    const init = function (selector)
    {
        $(selector).find(".distinctMultiSelectEEL").not(".eventsBound").each(function ()
        {
            skyward.distinctmultiselecteel.registerDistinctMultiSelectEEL($(this));
        });
    };

    skyward.distinctmultiselecteel.registerDistinctMultiSelectEEL = function (distinctMultiSelectEEL)
    {
        var lastValue = null;
        var layer = { onscreen: false };
        var data = distinctMultiSelectEEL.data();
        // Override automatic JSON-Parsing of additionalFields to preserve type on the return trip.
        data.additionalfieldinfo = distinctMultiSelectEEL.attr("data-additionalfieldinfo");
        data.sortfieldinfo = distinctMultiSelectEEL.attr("data-sortfieldinfo");
        var browseId;

        var dmseContainer = distinctMultiSelectEEL.closest("fieldset");
        var label = dmseContainer.find(".title");
        var selectedItems = distinctMultiSelectEEL.find("ul.selectedItems");
        selectedItems.find("a").prop("tabIndex", -1);
        var magnifyingGlass = selectedItems.children(".distinctMultiSelectSearchButton");
        var textbox = selectedItems.find(".distinctMultiSelectUserInput");
        var placeholder = textbox && textbox.length > 0 ? textbox[0].placeholder : null;
        var clearButton = distinctMultiSelectEEL.children(".distinctMultiSelectClearButton");
        var container = distinctMultiSelectEEL.find(".distinctMultiSelectContainer");

        showHidePlaceholder();
        showHideClearButton();

        label.on('click', function ()
        {
            if (!textbox.is(document.activeElement))
            {
                textbox.focus();
            }
        });

        if (label.length)
        {
            textbox.attr("aria-labelledby", label.addIds().attr("id"));
        }

        selectedItems.off('click').on('click', "a", null, removeTileButtonClicked);
        selectedItems.on('click', function ()
        {
            if (!textbox.is(document.activeElement))
            {
                textbox.focus();
            }
        });

        var dummyTile = selectedItems.find("li.dummyTile");

        var distinctMultiSelectEELData =
        {
            module: data.module,
            object: data.object,
            distinctfield: data.distinctfield,
            additionalfieldinfo: data.additionalfieldinfo,
            sortfieldinfo: data.sortfieldinfo,
            routeHash: data.routeHash,
            hidedistinctfield: data.hidedistinctfield,
            distinctfieldwidth: data.distinctfieldwidth,
            isSingleSelect: data.isSingleSelect,
            selectedItemKeys: [],
            filter: JSON.stringify(data.filter),
            hiddenBackingData: distinctMultiSelectEEL.find(".dmsBackingData"),
            rendernodatarow: data.rendernodatarow,
            browseName: data.browseName,
            browseId: data.browseId,
            tempTableName: data.tempTableName,
            isOnTheFly: data.isOnTheFly,
            dynamicfilterfield: data.dynamicfilterfield,
            dynamicfiltervalue: data.dynamicfiltervalue,
            distinctMultiSelectEELQueryParameterData: data.distinctMultiSelectEelQueryParameterData,
            hidePrimaryBrowseButton: data.hidePrimaryBrowseButton,
            readOnlySelectedItemIDs: data.readonlyselecteditemids,
            textbox: textbox,
            layer: null,
            forceSingleThread: data.forceSingleThread || false
        };

        var selectedKeyValuePairs = {};

        // Register selected items
        selectedItems.find("li.selectedItem").not(".dummyTile").each(function ()
        {
            var item = $(this);
            var targetId = item.data("targetid") + "";
            if (distinctMultiSelectEELData.selectedItemKeys.indexOf(targetId) === -1)
            {
                distinctMultiSelectEELData.selectedItemKeys.push(targetId);
                selectedKeyValuePairs[targetId] = item.text().trim();
            }
        });

        distinctMultiSelectEEL.find(".distinctMultiSelectSearchButton").off("click").on("click", function ()
        {
            if ($(this).is(".ui-disabled"))
            {
                return false;
            }

            if (layer.onscreen)
            {
                layer.close();
            }
            else
            {
                showPopup();
                doSearch(textbox.val(), undefined);
            }
        });

        distinctMultiSelectEEL.children(".distinctMultiSelectClearButton").off("click").on("click", function ()
        {
            if (layer.onscreen && !skyward.global.mobileAccess)
            {
                layer.close();
            }

            unselectAll();
        });

        resizeTextInput();

        distinctMultiSelectEELData.hiddenBackingData.on("workflowEnd", function (eventData, workflowData)
        {
            if ($.isEmptyObject(workflowData.updateControl) || distinctMultiSelectEELData.hiddenBackingData.attr("id") !== workflowData.updateControl.pageStateControl)
            {
                return false;
            }

            showPopup();
            doSearch("", workflowData.updateControl.primaryKey).then(function ()
            {
                const browse = skyward.browse.getInnerBrowse(distinctMultiSelectEELData.layer.container);
                if (browse === undefined)
                {
                    return;
                }
                const browseId = browse.id;
                // wait for the browse to load, so we can select the item that was added
                $(document).one("browseLoaded." + browseId, function ()
                {
                    const browse = skyward.browse.browseList[browseId];
                    const hasAnotherWorkflow = workflowData.redirectURL !== "";
                    let itemWasFound = false;

                    if (browse && browse.browse)
                    {
                        const checkbox = browse.browse.find(`.checkbox-button${getTargetIDSelector(workflowData.updateControl.primaryKey)}`).find(".checkbox");
                        itemWasFound = checkbox.length > 0;
                        if (itemWasFound && !checkbox.is(":checked"))
                        {
                            // simulate a click on the checkbox for the item.  This will update add the selected item to the DMSE.
                            checkbox.trigger("click");
                        }
                    }

                    // if there is a workflow, we want to close the DMSE so it doesn't appear in front of the workflow
                    if (skyward.workflow.getTopMostWorkflow().length)
                    {
                        distinctMultiSelectEELData.layer.close();
                    }

                    let deferred = $.Deferred().resolve().promise();

                    // if the item wasn't found, display a message to the user
                    if (!itemWasFound)
                    {
                        const errorDescriptionText = `There is a Filter applied to this List that is preventing the item from being selected. Try adding a new item or go to the ${browse.browseObject} List to modify your item.`;
                        deferred = skyward.modalLayer.showErrorDialog("The item you added cannot be made available for this list.", errorDescriptionText);
                    }

                    // In the event of a "Save & Add Another" scenario, we'll need to launch the next workflow
                    if (hasAnotherWorkflow)
                    {
                        deferred.then(function ()
                        {
                            skyward.workflow.callLoadContentFromUrl(workflowData);
                        });
                    }
                });
            });

            return true;
        });

        distinctMultiSelectEELData.hiddenBackingData.on("change", rebuildTilesFromBackingData);
        distinctMultiSelectEELData.hiddenBackingData.on("forceRebuild", rebuildTilesFromBackingData);

        textbox.on("keydown", function (event)
        {
            var eventKeys = skyward.keys.getKeyNamesFromEvent(event);
            var eventKeyIsPrintableChar = skyward.keys.isPrintableCharacter(event.keyCode);
            var isTriggerForDoSearch = eventKeys.ENTER || eventKeys.ARROW_DOWN || eventKeys.ARROW_UP || eventKeys.SPACE;
            var eventKeyIsDesirable = isTriggerForDoSearch || eventKeyIsPrintableChar;

            // If key isn't desirable or Tab then return true, the character is not one we want
            // to potentially use in the handler, i.e. ignore it and return focus
            if (!eventKeyIsDesirable || eventKeys.TAB)
            {
                return;
            }

            var continuePropagation = true;
            var textboxValue = textbox.val();
            var textboxIsEmpty = textboxValue.length === 0;

            if (layer.onscreen)
            {
                if (eventKeys.ENTER)
                {
                    continuePropagation = false;
                }
            }
            else
            {
                showPopup();

                if (isTriggerForDoSearch)
                {
                    doSearch(textboxValue, undefined);
                    event.preventDefault();
                    continuePropagation = false;
                }
            }
            if (eventKeys.BACKSPACE && textboxIsEmpty)
            {
                textbox.parent().prevAll().not(".dummyTile").first().find(".removeSelectedItem").click();
                searchTextChanged();
                textbox.focus();
            }

            return continuePropagation;
        });

        distinctMultiSelectEEL.on("clearAll", unselectAll);

        distinctMultiSelectEEL.addClass("eventsBound");


        function removeTileButtonClicked()
        {
            var targetId = $(this).closest("li").data("targetid");
            remove(targetId);
            updateBrowseCheckbox(targetId, false);

            setBackingData(selectedKeyValuePairs, true);

            refreshRelatedUI();

            return false;
        }

        function remove(targetId)
        {
            distinctMultiSelectEELData.selectedItemKeys = $.map(distinctMultiSelectEELData.selectedItemKeys, function (id)
            {
                var parsedId = typeof targetId === "number" ? parseInt(id) : id;

                if (targetId !== parsedId)
                {
                    return id;
                }
            });
            delete selectedKeyValuePairs[targetId];

            var tile = selectedItems.find(getTargetIDSelector(targetId));
            tile.remove();

            scrollInputIntoView();
        }

        function updateBrowseCheckbox(targetId, value)
        {
            if (layer.onscreen && layer.container instanceof $)
            {
                //uncheck related checkbox
                var checkbox = layer.container
                    .find(".unlockedBrowseBody .selectDistinctMultiSelectEELBrowseRow")
                    .filter(getTargetIDSelector(targetId))
                    .children("input");
                // ignore the next jschange event, (triggered when we change the property)
                checkbox.prop("checked", value);
            }
        }

        function unselectAll(event, suppressChange)
        {
            let valueToUse = {};
            if ((distinctMultiSelectEELData.readOnlySelectedItemIDs || []).length > 0)
            {
                const parsedData = JSON.parse(distinctMultiSelectEELData.hiddenBackingData.val())
                for (const key in parsedData)
                {
                    const value = parsedData[key];
                    for (const selectedItemID of distinctMultiSelectEELData.readOnlySelectedItemIDs)
                    {
                        if (key == selectedItemID)
                        {
                            valueToUse[key] = value;
                            break;
                        }
                    }
                }
            }

            selectedKeyValuePairs = valueToUse;
            setBackingData(valueToUse, false, suppressChange);

            if (layer.onscreen && layer.container instanceof $)
            {
                layer.container.find(".unlockedBrowseBody .selectDistinctMultiSelectEELBrowseRow").children("input").prop("checked", false);
            }
        }

        function add(targetId, displayText, suppressChangeEvent)
        {
            if (distinctMultiSelectEELData.isSingleSelect)
            {
                distinctMultiSelectEELData.selectedItemKeys.push(targetId);
            }
            else if (distinctMultiSelectEELData.selectedItemKeys.indexOf(targetId) === -1)
            {
                distinctMultiSelectEELData.selectedItemKeys.push(targetId);
            }
            selectedKeyValuePairs[targetId] = displayText;

            //DMSE UI - formerly function addTile(targetId, displayText)
            if (!selectedItems.has(getTargetIDSelector(targetId)).length)
            {
                var newTile = dummyTile.clone();
                // Apply an attr so we can use a [attr] search later to locate this tile
                newTile.attr("data-targetid", targetId);
                newTile.find("span").text(displayText || "");
                newTile.find("a").prop("tabIndex", -1);
                newTile.removeClass("dummyTile");
                newTile.insertBefore(dummyTile);

                if (!suppressChangeEvent)
                {
                    scrollInputIntoView(suppressChangeEvent);
                }
            }
        }

        function scrollInputIntoView()
        {
            textbox.select();
            textbox.scrollintoview({ duration: 0 });

            distinctMultiSelectEEL.scrollintoview({ duration: 0 });
        }

        function doSearch(searchText, seekId)
        {
            if ($.isEmptyObject(distinctMultiSelectEELData.layer) || !distinctMultiSelectEELData.layer.container instanceof $)
            {
                return $.Deferred().reject().promise();
            }
            var browse = distinctMultiSelectEELData.layer.container.find(".browse");
            browseId = browse.attr("id");

            // Attach key list somewhere we can access it from GetData();
            dmseDataByBrowse.set(browse[0], distinctMultiSelectEELData);
            var browseData = $.extend({}, distinctMultiSelectEELData);

            if (seekId !== undefined)
            {
                $.extend(browseData, { seekId: seekId });
            }
            else
            {
                $.extend(browseData, { distinctMultiSelectEELSearchText: skyward.extensions.encodeHtml(searchText) });
            }
            const request = skyward.browse.performDistinctMultiSelectEELSearch(browseId, browseData);
            requestHandler.request = request;
            return request.promise();
        }

        function setMassSelectButton()
        {
            if ($.isEmptyObject(layer) || !(layer.container instanceof $))
            {
                return;
            }
            distinctMultiSelectEELData.button = layer.container.find(".checkbox-mass-select-button");
            distinctMultiSelectEELData.button.on("click", function ()
            {
                setBrowseCurrentRecord(-1);
            });
        }

        function setBrowseCurrentRecord(row)
        {
            skyward.browse.setCurrentRecord(browseId, row, { loadRelatedBrowses: false });
        }

        var getBrowsePostData = function ()
        {
            const postData = container.data("postdata");

            if (distinctMultiSelectEELData.dynamicfilterfield && distinctMultiSelectEELData.dynamicfiltervalue)
            {
                var dependentFields = distinctMultiSelectEELData.dynamicfilterfield.split(',');
                var dependentValues = distinctMultiSelectEELData.dynamicfiltervalue.split(',');

                for (var i = 0; i < dependentFields.length; i++)
                {
                    var dependentElement = $('[name="' + dependentValues[i] + '"]');
                    if (dependentElement.length === 0)
                    {
                        dependentElement = $('#' + dependentValues[i] + ' .dmsBackingData');
                    }

                    if (dependentElement.hasClass('dmsBackingData'))
                    {
                        postData[dependentFields[i]] = skyward.distinctmultiselecteel.getSearchParameters(dependentElement);
                    }
                    else
                    {
                        postData[dependentFields[i]] = skyward.controls.getValue(dependentElement);
                    }
                }
            }

            return postData;
        };

        function showPopup()
        {
            delete skyward.browse.browseList[browseId];
            browseId = dmseIdGenerator.getNewId();

            const popupContent = $("<div>", { "class": "popup--browse", id: browseId + "_popup" });
            const popupBrowse = $("<div>", { id: browseId, "class": "browse browseStaticHeight" });
            popupContent.append(popupBrowse);

            const registeredBrowseData =
            {
                id: browseId,
                browse: popupBrowse,
                browseType: "DistinctMultiSelect",
                browseModule: distinctMultiSelectEELData.module,
                browseObject: distinctMultiSelectEELData.object,
                dataModule: distinctMultiSelectEELData.module, //TODO: PR 4339258 update to use actual dataModule instead of pageModule *note: this might not even be possible
                dataObject: distinctMultiSelectEELData.object, //TODO: PR 4339258 update to use actual dataObject instead of pageObject *note: this might not even be possible
                routeHash: distinctMultiSelectEELData.routeHash,
                refreshTimeout: -1,
                filter: distinctMultiSelectEELData.filter,
                keyEventsEnabled: true,
                additionalfieldinfo: distinctMultiSelectEELData.additionalfieldinfo,
                sortfieldinfo: distinctMultiSelectEELData.sortfieldinfo,
                distinctfield: distinctMultiSelectEELData.distinctfield,
                rendernodatarow: distinctMultiSelectEELData.rendernodatarow,
                hidedistinctfield: distinctMultiSelectEELData.hidedistinctfield,
                distinctfieldwidth: distinctMultiSelectEELData.distinctfieldwidth,
                selectedItemKeys: distinctMultiSelectEELData.selectedItemKeys,
                browseName: distinctMultiSelectEELData.browseName,
                browseId: distinctMultiSelectEELData.browseId,
                isOnTheFly: distinctMultiSelectEELData.isOnTheFly,
                successCallback: setMassSelectButton,
                data: getBrowsePostData(),
                queryParameterData: distinctMultiSelectEELData.distinctMultiSelectEELQueryParameterData,
                hidePrimaryBrowseButton: distinctMultiSelectEELData.hidePrimaryBrowseButton,
                hiddenBackingDataId: distinctMultiSelectEELData.hiddenBackingData.attr('id')
            };

            if (distinctMultiSelectEELData.rowsPerPage)
            {
                registeredBrowseData.rowsPerPage = distinctMultiSelectEELData.rowsPerPage;
            }

            skyward.browse.browseList[browseId] = registeredBrowseData;

            skyward.browse.openBrowses.push(browseId);

            const beforeClose = function ()
            {
                // When the modal layer closes, browses within it will be hidden, so abort open requests.
                requestHandler.closeOpenRequest();
                textbox.val("");
                if (!skyward.global.mobileAccess)
                {
                    textbox.focus();
                }

                lastValue = null;

                if (registeredBrowseData.rowsPerPage)
                {
                    distinctMultiSelectEELData.rowsPerPage = registeredBrowseData.rowsPerPage;
                }

                // null out our references to the layer so it can be garbage-collected
                layer = { onscreen: false };
                distinctMultiSelectEELData.layer = null;
                container.off("wheel", onlyScrollSelectedItems);
            };

            const afterClose = function ()
            {
                distinctMultiSelectEEL.trigger("modalClosed");
            };

            const bindings =
                [
                    {
                        onEvents: "input",
                        bindTo: textbox,
                        runFunction: resizeTextInput
                    },
                    {
                        onEvents: "input",
                        bindTo: textbox,
                        runFunction: skyward.debounce(searchTextChanged)
                    },
                    {
                        onEvents: "keydown",
                        bindTo: textbox,
                        runFunction: function (event)
                        {
                            const eventKeys = skyward.keys.getKeyNamesFromEvent(event);

                            if (eventKeys.TAB)
                            {
                                layer.close();
                            }
                            else if (eventKeys.ENTER)
                            {
                                const selectAllCellSelected = layer.contents.find(".js-massSelectCell.current");
                                if (selectAllCellSelected.length > 0)
                                {
                                    if (distinctMultiSelectEELData.button)
                                    {
                                        distinctMultiSelectEELData.button.trigger("click");
                                    }
                                }
                                else
                                {
                                    layer.contents.find(".browseRow.current .selectDistinctMultiSelectEELBrowseRow").first().click();
                                }
                                event.preventDefault();
                            }
                        }
                    },
                    {
                        onEvents: "click",
                        bindTo: magnifyingGlass,
                        runFunction: closeLayer
                    },
                    {
                        onEvents: `rowChanged browseLoaded.${browseId}`,
                        bindTo: popupBrowse,
                        runFunction: function (_event)
                        {
                            const browse = skyward.browse.browseList[browseId];
                            const row = skyward.browse.getCurrentRowElement("unlocked", browseId, browse.currentRow, "DistinctMultiSelect");
                            textbox.attr("aria-activedescendant", row.addIds().attr("id"));
                        }
                    }
                ];

            layer = skyward.modalLayer.showCodeEELDialog(popupContent, textbox, container, beforeClose, distinctMultiSelectEELData, bindings, afterClose);

            const selectedItemsElement = selectedItems.get(0);
            container.on("wheel", onlyScrollSelectedItems);

            layer.container.off("change").on("change", ".checkbox", null, checkboxClicked);
            layer.container.data("scopedMassSelect", scopedMassSelect);

            textbox.focus();

            function closeLayer()
            {
                layer.close();
            }

            function onlyScrollSelectedItems(scrollEvent)
            {
                if (!skyward.window.hasVerticalScrollBar(selectedItems))
                {
                    scrollEvent.preventDefault();
                    return;
                }

                const scrolledToTop = selectedItemsElement.scrollTop === 0;
                const scrollingUp = scrollEvent.originalEvent.deltaY < 0;
                if (scrolledToTop && scrollingUp)
                {
                    scrollEvent.preventDefault();
                    return;
                }

                const scrolledToBottom = selectedItemsElement.scrollTop + selectedItems.outerHeight() === selectedItemsElement.scrollHeight;
                const scrollingDown = scrollEvent.originalEvent.deltaY > 0;
                if (scrolledToBottom && scrollingDown)
                {
                    scrollEvent.preventDefault();
                    return;
                }

                const targetElement = scrollEvent.target;
                const targetOustideOfSelectedItems = selectedItemsElement !== targetElement && !$.contains(selectedItemsElement, targetElement);
                if (targetOustideOfSelectedItems)
                {
                    scrollEvent.preventDefault();
                    return;
                }
            }
        }

        function resizeTextInput()
        {
            const inputPadding = 20;

            const textWidth = skyward.global.calculateTextWidthPx(textbox.val()) + inputPadding;
            const placeholderWidth = skyward.global.calculateTextWidthPx(textbox.attr("placeholder")) + inputPadding; // use current placeholder value, not the original value

            textbox.css(
                {
                    "width": Math.max(textWidth, placeholderWidth) + "px"
                });
        }

        function checkboxClicked()
        {
            var checkbox = $(this);
            var checkboxButton = $(this).closest('.checkbox-button');
            var targetId = checkboxButton.data("targetid");
            targetId = targetId !== null ? targetId.toString() : "";
            var row = checkboxButton.closest("tr");
            var displayText = row.find(".browseDataCell").first().text();
            var checked = checkbox.is(":checked");

            if (checked)
            {
                if (distinctMultiSelectEELData.isSingleSelect)
                {
                    unselectAll(null, true);
                }
                add(targetId, displayText, false);
            }
            else
            {
                remove(targetId);
            }

            if (distinctMultiSelectEELData.isSingleSelect)
            {
                layer.close();
            }

            setBrowseCurrentRecord(row.prevAll().length);

            setBackingData(selectedKeyValuePairs, true);

            toggleCheckedAllOfId(row.closest('.browseBody'), targetId, checked);
            refreshRelatedUI();
        }

        function toggleCheckedAllOfId(browseBody, targetId, checked)
        {
            browseBody.find('.checkbox-button').each(function ()
            {
                var button = $(this);
                var buttonId = button.data('targetid');
                if (buttonId === targetId)
                {
                    skyward.controls.setValue(button.children('.checkbox'), checked, true);
                }
            });
        }

        function searchTextChanged()
        {
            // Since this function can be called from a debounce, we want to ensure that the user still has focus within the input
            // when this function is called. For instance, if a user presses tab we don't want to return focus to the search input.
            if (document.activeElement != textbox.get(0))
            {
                return;
            }
            const searchText = textbox.val();
            resizeTextInput();

            if (lastValue !== null && searchText.toLowerCase() === lastValue.toLowerCase())
            {
                return;
            }

            if (distinctMultiSelectEELData.layer == null)
            {
                showPopup();
            }

            lastValue = searchText;
            doSearch(searchText, undefined);
        }

        function scopedMassSelect(button)
        {
            button = $(button);
            var browse = skyward.browse.browseList[browseId];
            if (!browse)
            {
                return null;
            }

            if (button.hasClass("noneChecked"))
            {
                var browseData = skyward.browse.getRequiredBrowseData(browse, {});
                var url = skyward.global.virtualDir + browse.browseModule + "/" + browse.browseObject + '/SelectAll';

                var searchText = { distinctMultiSelectEELSearchText: skyward.extensions.encodeHtml(textbox.val()) };
                $.extend(browseData, searchText);

                $.ajax(
                    {
                        url: url,
                        type: "POST",
                        dataType: "JSON",
                        activityIndicator: { hideGlass: true },
                        success: function (data)
                        {
                            $.each(data.Results, function (i, v)
                            {
                                add(v.id, v.name, false);
                                updateBrowseCheckbox(v.id, true);
                            });

                            updateBackingDataFromDOM();
                            refreshRelatedUI();
                        },
                        data: browseData
                    });
            }
            else
            {
                unselectAll();
            }

            return $.Deferred().reject();
        }

        function getTargetIDSelector(targetID)
        {
            return "[data-targetid='" + escapeSpecialChars(targetID) + "']";
        }

        function showHideClearButton()
        {
            if (selectedItems.has("[data-targetid]").length > 0)
            {
                clearButton.show();
            }
            else
            {
                clearButton.hide();
            }
        }

        function showHidePlaceholder()
        {
            showHidePlaceholderShared(selectedItems, textbox, placeholder);
            resizeTextInput();
        }

        function escapeSpecialChars(input)
        {
            return input.toString().replace(/[!"#$%&'()*+,.\/:;<=>?@[\\\]^`{|}~]/g, "\\$&");
        }

        function setBackingData(value, dontRebuildTiles, suppressChange) // Triggers a change event, which normally will redraw UI.
        {
            if (dontRebuildTiles)
            {
                distinctMultiSelectEELData.hiddenBackingData.off("change", rebuildTilesFromBackingData);
            }
            skyward.controls.setValue(distinctMultiSelectEELData.hiddenBackingData, typeof value === 'string' ? value : JSON.stringify(value), suppressChange);
            if (dontRebuildTiles)
            {
                distinctMultiSelectEELData.hiddenBackingData.on("change", rebuildTilesFromBackingData);
            }
        }

        function updateBackingDataFromDOM()
        {
            selectedKeyValuePairs = {};
            distinctMultiSelectEELData.selectedItemKeys = [];
            scrapeTokensForSelectedValues(distinctMultiSelectEELData.hiddenBackingData, function (key, value)
            {
                distinctMultiSelectEELData.selectedItemKeys.push(key);
                selectedKeyValuePairs[key] = value;
            });

            setBackingData(selectedKeyValuePairs, true);
        }

        function rebuildTilesFromBackingData(event, suppressChangeEvent)
        {
            distinctMultiSelectEELData.selectedItemKeys = [];
            selectedKeyValuePairs = {};

            $("#" + browseId).data('selectedItemKeys', distinctMultiSelectEELData.selectedItemKeys);

            var tiles = selectedItems.find(":not(.dummyTile) a").closest("li");
            tiles.remove();

            $.each(JSON.parse(distinctMultiSelectEELData.hiddenBackingData.val()), function (key, value)
            {
                add(key, value, suppressChangeEvent);
                updateBrowseCheckbox(key, true);
            });

            refreshRelatedUI();
        }

        function refreshRelatedUI()
        {
            if (layer.onscreen && typeof layer.options.resizeCallback === "function")
            {
                layer.options.resizeCallback();
            }

            if (distinctMultiSelectEELData.button)
            {
                distinctMultiSelectEELData.button
                    .data("selectedRecordCount", distinctMultiSelectEELData.selectedItemKeys.length)
                    .trigger("selectedRecordCountChanged");
            }

            showHideClearButton();
            showHidePlaceholder();
        }
    };

    var scrapeTokensForSelectedValues = function (backingDataElement, callback)
    {
        backingDataElement.siblings(".distinctMultiSelectContainer").find(".selectedItems").find(".selectedItem").not(".dummyTile").each(function ()
        {
            var selectedItem = $(this);
            var key = selectedItem.data().targetid;
            key = typeof key === "number" ? key.toString() : key;
            var value = selectedItem.text().trim();
            callback(key, value);
        });
    };

    var forEachSelectedValue = function (backingDataElement, callback)
    {
        var stringValue = backingDataElement.val();
        var valueList = JSON.parse(stringValue ? stringValue : "{}");

        for (var key in valueList)
        {
            callback(key, valueList[key]);
        }
    };

    function showHidePlaceholderShared(selectedItems, textbox, placeholder)
    {
        if (!placeholder)
        {
            return;
        }

        if (selectedItems.has("[data-targetid]").length)
        {
            textbox[0].placeholder = "";
        }
        else
        {
            textbox[0].placeholder = placeholder;
        }
    }

    skyward.distinctmultiselecteel.getOriginalValue = function (element)
    {
        var values = element.data("original-value");

        var searchParameters = [];
        var valueList = {};

        // sort values so dirty logic is smarter
        for (const key of Object.keys(values).sort())
        {
            const encodedKey = skyward.extensions.encodeHtml(key);
            searchParameters.push(encodedKey);
            valueList[encodedKey] = skyward.extensions.encodeHtml(values[key]);
        }

        if (element.hasClass('returnValueListAsKeys'))
        {
            return searchParameters;
        }

        return valueList;
    };

    skyward.distinctmultiselecteel.changeTracking = function (element, value, originalValue)
    {
        if (!element.hasClass('returnValueListAsKeys'))
        {
            value = Object.keys(value);
            originalValue = Object.keys(originalValue);
        }

        return value.length === originalValue.length && $(value).not(originalValue).length === 0 && $(originalValue).not(value).length === 0;
    };

    skyward.distinctmultiselecteel.getValue = function (element)
    {
        var searchParameters = [];
        var valueList = {};

        forEachSelectedValue(element, function (key, value)
        {
            const encodedKey = skyward.extensions.encodeHtml(key);
            const encodedValue = skyward.extensions.encodeHtml(value);

            searchParameters.push(encodedKey);
            valueList[encodedKey] = encodedValue;
        });

        if (element.hasClass('returnValueListAsKeys'))
        {
            return searchParameters;
        }

        return valueList;
    };

    skyward.distinctmultiselecteel.setValue = function (element, value, suppressChangeEvent)
    {
        var stringValue = typeof value === "object" ? JSON.stringify(value) : value;
        element.val(stringValue);
        if (!suppressChangeEvent)
        {
            element.change();
        }
        else
        {
            element.trigger("forceRebuild", [suppressChangeEvent]);
        }
    };

    skyward.distinctmultiselecteel.isEmpty = function (backingDataElement)
    {
        var stringValue = backingDataElement.val();
        return !stringValue || stringValue === "{}";
    };

    skyward.distinctmultiselecteel.getSearchParameters = function (element)
    {
        var searchParameters = [];

        forEachSelectedValue(element, function (key, value)
        {
            searchParameters.push(key);
        });

        return searchParameters;
    };

    skyward.distinctmultiselecteel.clearValue = function (element, suppressChange)
    {
        // all code for clearing DMSEs should be in the 'clearAll' event, and
        // the values should only be cleared with the skyward.controls.clearValue() function
        element.trigger("clearAll", suppressChange);
    };

    skyward.distinctmultiselecteel.massSelect = function (button)
    {
        var scopedMassSelect = $(button).closest("div.modalLayerContainer").data("scopedMassSelect");
        if (typeof scopedMassSelect === 'function')
        {
            return scopedMassSelect.apply(this, arguments);
        }
    };

    function buildPromptDataCollection(hiddenBackingDataID)
    {
        const hiddenBackingDataElement = $("#" + hiddenBackingDataID);
        const promptDataCollection = [];
        if (hiddenBackingDataElement.hasClass("hasDependentPrompts"))
        {
            const dependentPromptUniqueIds = hiddenBackingDataElement.data().dependentPromptUniqueIds;

            let closestContentSelector = ".workflowContent, .currentRecordContent";
            if (hiddenBackingDataElement.parents().hasClass("carbonCopyOptionFilterWrapper"))
            {
                //carbon copy option filters should only get dependent values inside it's own area
                closestContentSelector = ".carbonCopyOptionFilterWrapper"
            }
            const content = hiddenBackingDataElement.closest(closestContentSelector);

            for (let i = 0; i < dependentPromptUniqueIds.length; i++)
            {
                const dependentPromptUniqueId = dependentPromptUniqueIds[i];
                const dependentPrompt = content.find(".filterValue[data-prompt-unique-id='" + dependentPromptUniqueId + "']")
                const isDistinctMultiSelect = dependentPrompt.hasClass("distinctMultiSelectEEL");
                const isMultiSelectBox = dependentPrompt.hasClass("multipleSelectBox");
                let dependentPromptValue = null;

                if (isDistinctMultiSelect)
                {
                    dependentPromptValue = skyward.controls.getValue(dependentPrompt.find(".dmsBackingData"));
                }
                else if (isMultiSelectBox)
                {
                    dependentPromptValue = skyward.controls.getValue(dependentPrompt.find(".multiSelectBackingData"));
                }
                else
                {
                    dependentPromptValue = skyward.controls.getValue(dependentPrompt);
                }

                let promptData = dependentPrompt.data();
                let isHidden = dependentPrompt.closest(".promptFieldSet").is(":hidden");
                promptDataCollection.push({
                    UniqueID: dependentPromptUniqueId,
                    BoundValue: isHidden ? null : dependentPromptValue,
                    Type: promptData.promptType,
                    PresenceType: promptData.presenceType,
                    DataType: promptData.fieldType,
                    IsHidden: isHidden,
                });
            }
        }
        return promptDataCollection;
    }

    skyward.distinctmultiselecteel.getData = function (browse)
    {
        var browseElem = browse.browse;
        var dmseData = dmseDataByBrowse.get(browseElem[0]);
        var data =
        {
            module: browse.browseModule,
            object: browse.browseObject,
            browseType: "DistinctMultiSelect",
            refreshTimeout: -1,
            selectedItemKeys: skyward.extensions.encodeHtml(JSON.stringify(dmseData.selectedItemKeys)),
            filter: skyward.extensions.encodeHtml(browse.filter),
            sortfieldinfo: browse.sortfieldinfo,
            distinctMultiSelectEELSearchText: skyward.extensions.encodeHtml(dmseData.textbox.val())
        };

        if (browse.rowsPerPage)
        {
            data.rowsPerPage = browse.rowsPerPage;
        }

        if (browse.hiddenBackingDataId && browse.hiddenBackingDataId.length > 0)
        {
            var promptDataCollection = buildPromptDataCollection(browse.hiddenBackingDataId);
            data.promptDataCollection = JSON.stringify(promptDataCollection);
        }
        return data;
    };

    skyward.window.registerLoadDOMCallback(init);
}(window.skyward = window.skyward || {}, window.jQuery));
